var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAudioToAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 19",
    id: "Layer_19"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "14.52 28.67 14.52 62.22 11.12 62.22 11.12 28.67"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "11.12 11.39 11.12 1.66 14.52 1.66 14.52 11.39"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "33.71 57.29 33.71 62.22 30.31 62.22 30.31 57.29"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "30.31 40.02 30.31 1.66 33.71 1.66 33.71 40.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "52.9 35.75 52.9 62.22 49.49 62.22 49.49 35.75"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "49.49 18.64 49.49 1.66 52.9 1.66 52.9 18.64"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.62,
    cy: 20.03,
    r: 8.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.62,
    cy: 20.03,
    r: 5.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 32.01,
    cy: 48.66,
    r: 8.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 32.01,
    cy: 48.66,
    r: 3.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.2,
    cy: 27.28,
    r: 8.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.2,
    cy: 27.28,
    r: 4.69
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAudioToAudio);
export default __webpack_public_path__ + "static/media/icon-audioToAudio.f9ff4a88d4b1d8396b0cf40c6db837e6.svg";
export { ForwardRef as ReactComponent };